import { render, staticRenderFns } from "./modal-add-exercise.vue?vue&type=template&id=5105a58a&scoped=true&lang=pug"
import script from "./modal-add-exercise.js?vue&type=script&lang=js&external"
export * from "./modal-add-exercise.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-exercise.vue?vue&type=style&index=0&id=5105a58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5105a58a",
  null
  
)

export default component.exports